import {useState, useEffect} from 'react';

export default function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if(entry.intersectionRatio===1){
            setIntersecting(true);
          }
          else {setIntersecting(false);}

        });
      }, {threshold: 1}
    )

    useEffect(() => {
      observer.observe(ref.current)
      // Remove the observer as soon as the component is unmounted
      return () => { observer.disconnect() }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return isIntersecting
  }
